<template>
    <nav class="navbar is-white is-dark" id="appheader">
        <div class="navbar-brand" id="navMenu">
            <!-- <a class="navbar-item brand-text" href="#/changes">
                Main
            </a> -->
            <div class="navbar-burger burger" v-bind:class="{'is-active':isMobile}" v-on:click="isMobile = !isMobile">
               <span aria-hidden="true"></span>
               <span aria-hidden="true"></span>
               <span aria-hidden="true"></span>
            </div>
        </div>
        <div id="navMenu" class="navbar-menu" v-bind:class="{'is-active':isMobile}" >
          <div class="navbar-start">
            <a class="navbar-item" href="#/changes" v-on:click="selectedItem = '/changes'"
               v-bind:class="{'is-active': selectedItem == '/changes'}">
              Changes
            </a>
            <a class="navbar-item" href="#/products" v-on:click="selectedItem = '/products'"
               v-bind:class="{'is-active': selectedItem == '/products'}">
              Products
            </a>
            <a class="navbar-item" href="#/productGroups" v-on:click="selectedItem = '/productGroups'"
               v-bind:class="{'is-active': selectedItem == '/productGroups'}">
              Product Groups
            </a>
            <a class="navbar-item" href="#/versions" v-on:click="selectedItem = '/versions'"
               v-bind:class="{'is-active': selectedItem == '/versions'}">
              Versions
            </a>
            <a v-if="this.userRole == 'admin'" class="navbar-item" href="#/logs" v-on:click="selectedItem = '/logs'"
               v-bind:class="{'is-active': selectedItem == '/logs'}">
              CRUD Logs
            </a>
            <a v-if="this.userRole == 'admin'" class="navbar-item" href="#/admin" v-on:click="selectedItem = '/admin'"
               v-bind:class="{'is-active': selectedItem == '/admin'}">
              Admin Panel
            </a>
          </div>


            <div class="navbar-end">
              <div class="navbar-item has-dropdown" id="profileMenu" v-bind:class="{'is-active': dropdownActive}" v-on:click="dropdownActive = !dropdownActive">
                <a class="navbar-link">
                  <span>
                    {{userName}}
                  </span>
                </a>
                <div class="navbar-dropdown is-right">
                  <a class="navbar-item" href="https://id.fast-report.com/Manage" target="_blank">
                    Profile
                  </a>
                  <a class="navbar-item" v-on:click.prevent="goToSettings">
                    Settings
                  </a>
                  <a class="navbar-item" v-on:click.prevent="logout">
                    <span class="icon">
                      <i class="fas fa-sign-out-alt"></i>
                    </span>
                    <span>
                     Log out
                    </span>
                  </a>
                </div>
              </div>
            </div>

        </div>
    </nav>
</template>

<script>
//import this.HTTP from "./Http";

export default {
  name: "app-header",
  data() {
    return {
      isMobile: false,
      selectedItem: this.$route.path.toLowerCase(),
      dropdownActive: false
    };
  },
  // computed: {
  //   profile: function() {
  //     return this.$userName;
  //   }
  // },
  methods: {
    logout() {
      this.HTTP.deleteUserProfile();
      this.HTTP.logout();
    },
    goToSettings() {
      this.$router.push("ProfileSettings");
    },
    onMouseOutListener(e) {
      let header = document.getElementById("appheader");
      if (header != undefined && header.contains(e.target)) {
      } else {
        this.isMobile = false;
      }
      let profileMenu = document.getElementById("profileMenu");
      if (
        profileMenu != undefined &&
        !document.getElementById("profileMenu").contains(e.target)
      ) {
        this.dropdownActive = false;
      }
    }
  },
  created() {
    window.addEventListener("mouseout", this.onMouseOutListener);
    this.HTTP.load();
    //if (this.HTTP.getToken()) {
    //this.profile = "Sign Out";
  },
  beforeDestroy() {
    window.removeEventListener("mouseout", this.onMouseOutListener);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.Vue